// src/pages/NewsDetail.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import "../App.css";

const NewsDetail = () => {
  const { id } = useParams();
  const [news, setNews] = useState(null);

  useEffect(() => {
    const fetchNewsItem = async () => {
      const docRef = doc(db, "news", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setNews({
          ...data,
          date: data.date?.toDate() || null,
        });
      }
    };
    fetchNewsItem();
  }, [id]);

  if (!news) return <p>Loading...</p>;

  return (
    <section className="news_detail_page">
      <h2>{news.title}</h2>
      <p className="news_date">
        {news.date ? news.date.toLocaleDateString("en-NZ", {
          year: "numeric",
          month: "long",
          day: "numeric"
        }) : "No date"}
      </p>
      <img src={news.image} alt={news.title} className="news_detail_image" />
      <p className="news_detail_desc">{news.desc}</p>
    </section>
  );
};

export default NewsDetail;
